module.exports = __webpack_public_path__ + "media/images/backToTop-4a234d0c704d5f381a3d6fb652845048.svg";